import { formatIcuString } from './Locale';
import type { LocaleCode } from './Locale';

/**
 * Format a count message from Pimcore content structure.
 *
 * @param template - The ICU format string with `count` variable, e.g. "Compare {count, plural, one {# Part} other {# Parts}}"
 * @param count - The count value to substitute
 * @param locale - The locale code (e.g. "en", "zh", "ja")
 * @returns Formatted string
 */
export function formatCountIcuString(template: string, count: number, locale: LocaleCode): string {
    return formatIcuString(template, { count }, locale);
}
